import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { INVENTORY_PUB_STATES, srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { getBuildAndPriceLink } from 'site-modules/shared/utils/build-and-price-link-constructor';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';
import { Link } from 'site-modules/shared/components/link/link';

function NeedMoreHelpUI({ className = null, linksClassName = null, vehicleParams: { make, model, year } }) {
  const links = [
    {
      label: 'See all for sale',
      url: srpLinkBuilder({ inventorytype: INVENTORY_PUB_STATES.NEW }),
      trackingId: 'view_search_result',
    },
    {
      label: 'Calculate Payments',
      url: '/calculators/simplified-pricing.html',
      trackingId: 'pc_link_to_calculator',
      trackingValue: 'calculate_payments',
    },
    {
      label: 'Evaluate Your Trade-In',
      url: URL_PATHS.APPRAISAL_LANDING,
      trackingId: 'tool_select_appraise_your_car',
      trackingValue: 'Appraise this car',
    },
    { label: 'Shopper Forums', url: 'https://forums.edmunds.com/', trackingId: 'pc_shopper_forums' },
  ];

  if (make && model && year) {
    links.push({
      label: `Build & Price a ${year.year} ${make.name} ${model.name}`,
      url: getBuildAndPriceLink({ make: make.slug, model: model.slug, year: year.year }),
      trackingId: 'configure_vehicle',
    });
  }

  return (
    <div className={classnames('need-more-help', className)} data-tracking-parent="price-checker_shopping_links">
      <div className="heading-4 mb-1_5">Need more help?</div>
      <Row className={linksClassName}>
        {links.map(({ label, url, trackingId, trackingValue }) => (
          <Col key={url} xs={6} md={4} className="mb-0_5">
            <Link
              to={url}
              className="text-primary-darker"
              data-tracking-id={trackingId}
              data-tracking-value={trackingValue}
            >
              {label}
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}

NeedMoreHelpUI.propTypes = {
  vehicleParams: PropTypes.shape({
    make: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
    model: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
    year: PropTypes.shape({
      year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
  className: PropTypes.string,
  linksClassName: PropTypes.string,
};

export const NeedMoreHelp = React.memo(NeedMoreHelpUI);
